const AUTH_TOKEN_KEY = 'growchat_token'
const REFRESH_TOKEN_KEY = 'growchat_refresh_token'

export function getAuthToken() {
  let t = localStorage.getItem(AUTH_TOKEN_KEY)
  return t
}

export function setAuthToken(token) {
  localStorage.setItem(AUTH_TOKEN_KEY, token)
}

export function clearAuthToken() {
  localStorage.removeItem(AUTH_TOKEN_KEY)
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export function setRefreshToken(token) {
  localStorage.setItem(REFRESH_TOKEN_KEY, token)
}

export function clearRefreshToken() {
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}
